import { BROWSER_STORAGE_KEYS } from "utils/constants"
import { UserPreferenceManager } from "utils/userPreferenceManager"

import { SpnyTourEnum, SpnyTourType } from "../Context"
import ResumeTourBox from "../ResumeTourBox"
import { useTourContext } from "../TourProvider"

const ResumeImpactCpatDashboardTour = () => {
  const { step, setStep, setStepIndex } = useTourContext()
  const spnyCpatDashboardTour = UserPreferenceManager.get(
    BROWSER_STORAGE_KEYS.spnyCpatDashboardTour
  ) as SpnyTourType

  if (spnyCpatDashboardTour === SpnyTourEnum.initiated && !step) {
    return (
      <ResumeTourBox
        title="Take a quick tour of the Assessment Tab?"
        subTitle="Get a quick walkthrough of how to start assessments, navigate them, and view reports."
        onContinue={() => {
          setStepIndex(0)
          setStep("joyride")
        }}
      />
    )
  }
  return null
}

export default ResumeImpactCpatDashboardTour
